'use client'

import { ReactNode, useState } from 'react'
import { Text, InfoBanner } from '@vinted/web-ui'

import { clickEvent } from '@marketplace-web/bundles/items-bundle-data'
import { CurrencyAmountModel } from '@marketplace-web/currency/currency-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import ItemVerificationBuyerModal from '../ItemVerificationBuyerModal'

type Props = {
  itemVerificationFee?: CurrencyAmountModel | null
}

const ItemVerificationBundleInfoBanner = ({ itemVerificationFee }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const translate = useTranslate('bundle_items')
  const { track } = useTracking()

  const handleOfflineVerificationClick = () => {
    setIsModalOpen(true)

    track(clickEvent({ target: 'physical_auth_buyer' }))
  }

  const handleCloseModal = () => setIsModalOpen(false)

  const values = {
    'how-it-works': (chunks: Array<ReactNode>) => (
      <span key="how-it-works">
        <button type="button" onClick={handleOfflineVerificationClick}>
          <Text
            clickable
            text={chunks}
            type="subtitle"
            testId="offline-verification-info-banner-link"
            as="a"
          />
        </button>
      </span>
    ),
  }

  if (!itemVerificationFee) return null

  return (
    <>
      <InfoBanner
        testId="offline-verification-info-banner"
        styling="tight"
        type="warning"
        body={
          <Text
            as="h3"
            text={translate('authenticity_note', values)}
            type="subtitle"
            theme="amplified"
          />
        }
      />
      <ItemVerificationBuyerModal
        show={isModalOpen}
        onClose={handleCloseModal}
        verificationFee={itemVerificationFee}
      />
    </>
  )
}

export default ItemVerificationBundleInfoBanner
